module.exports = __webpack_public_path__ + "2117818d2598be59f2361a845f25b0f0.png";